// extracted by mini-css-extract-plugin
export var lg = "_3n-4";
export var md = "_3n-3";
export var sm = "_3n-2";
export var xs = "_3n-1";
export var xxs = "_3n-0";